import type { AxiosResponse } from 'axios';
import { adminAxios } from 'utils/adminAxios';

export const postSignInRefresh = async (): Promise<AxiosResponse> => {
  return await adminAxios.post('/sign_in/refresh');
};
